import React from 'react';

const SupportAccordion = () => {
  // 카테고리 및 상세 서비스 데이터
  const serviceData = [
    {
      category: "IT 커리어",
      id: "accordionCareer",
      items: [
        {
          id: "Career1",
          title: "독일 IT 기업 취업 & 실전 면접 컨설팅",
          content: "독일식 이력서(CV) 최적화는 물론, 테크니컬 인터뷰 준비법, 독일 기업이 선호하는 컬처 핏(Culture Fit) 대응 전략, 연봉 협상 노하우까지 합격을 위한 실전 코칭과 디테일한 면접 조언을 제공합니다."
        }
      ]
    },
    {
      category: "비자",
      id: "accordionVisa",
      items: [
        {
          id: "Visa1",
          title: "블루카드 / 취업 / 학생 / 인턴 / 임시비자",
          content: "각 목적에 맞는 독일 비자 신청 자격 확인, 서류 준비 및 작성 후 검토, 외국인청 예약(Termin) 가이드를 제공합니다."
        }
      ]
    },
    {
      category: "행정 / 거주",
      id: "accordionAdmin",
      items: [
        {
          id: "Admin1",
          title: "전입신고(Anmeldung) 및 세금번호 발급",
          content: "독일 거주의 첫 단계인 안멜둥 절차와 거주지 등록 후 자동으로 발급되는 세금번호(Identifikationsnummer) 확인법을 안내합니다."
        },
        {
          id: "Admin2",
          title: "운전면허 교환 안내",
          content: "한국 운전면허증을 독일 면허증으로 공증 및 교환하는 방법과 필요한 서류 리스트를 제공합니다."
        }
      ]
    },
    {
      category: "가족 / 복지",
      id: "accordionFamily",
      items: [
        {
          id: "Family1",
          title: "킨더겔트(Kindergeld) 신청",
          content: "독일에 거주하는 자녀를 위한 아동수당 신청 방법과 Familienkasse 제출 서류를 안내하며, 서류 작성 후 검토까지 지원해 드립니다."
        },
        {
          id: "Family2",
          title: "키타(Kita) 및 학교 등록 안내",
          content: "거주지 근처 키타 찾기(Kita-Gutschein) 및 독일 공립/사립 학교 입학 절차에 대해 설명합니다."
        }
      ]
    },
    {
      category: "생활 / 계약",
      id: "accordionLiving",
      items: [
        {
          id: "Living1",
          title: "인터넷 / 전기 / 가스 설치",
          content: "독일 주요 공급업체 비교와 신규 계약 및 이전 설치 시 주의사항을 확인하세요."
        },
        {
          id: "Living2",
          title: "핸드폰 요금제 및 방송수신료(GEZ)",
          content: "합리적인 통신사 선택법과 독일 모든 가구의 의무인 방송수신료 납부 가이드를 제공합니다."
        }
      ]
    },
    {
      category: "보험 / 금융",
      id: "accordionFinance",
      items: [
        {
          id: "Finance1",
          title: "의료 / 책임 / 법률보험 가입",
          content: "독일 생활 필수 보험인 공보험/사보험 비교와 일상 배상책임보험(Haftpflichtversicherung) 안내입니다."
        },
        {
          id: "Finance2",
          title: "은행계좌 개설 (슈페어콘토 포함)",
          content: "일반 입출금 계좌(Girokonto) 개설과 학생 비자용 슈페어콘토(Sperrkonto) 이용 방법을 설명합니다."
        }
      ]
    }
  ];

  return (
    <section className="py-5 bg-light">
      {/* 대표 문구 섹션 추가 */}
      <div className="text-center mb-5">
        <h2 className="fw-bold mb-3" style={{ fontFamily: 'Nanum Gothic' }}>독일 IT 커리어 & 프리미엄 정착 솔루션</h2>
        <p className="text-muted mx-auto" style={{ maxWidth: '700px', fontSize: '1.05rem' }}>
          성공적인 블루카드 승인부터 복잡한 행정 절차까지, <br className="d-none d-md-block" />
          독일 현지 IT 전문가가 여러분의 안정적인 정착을 완벽하게 가이드합니다.
        </p>
      </div>
      <div className="container py-4 py-xl-5" style={{ maxWidth: '800px' }}>
        {serviceData.map((group) => (
          <div key={group.id} className="mb-5">
            <h4 className="fw-bold mb-3">{group.category}</h4>
            <div className="accordion" id={group.id}>
              {group.items.map((item) => (
                <div className="accordion-item" key={item.id}>
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse${item.id}`}
                      aria-expanded="false"
                      aria-controls={`collapse${item.id}`}
                    >
                      {item.title}
                    </button>
                  </h2>
                  <div
                    id={`collapse${item.id}`}
                    className="accordion-collapse collapse"
                    data-bs-parent={`#${group.id}`}
                  >
                    <div className="accordion-body">
                      {item.content}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SupportAccordion;